import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Loader from 'react-loader';
import { Container, Button } from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import { fetchPages } from '../modules/PageList/actions';
import { isLoaded, getError } from '../modules/PageList/reducer';
import PageList from '../modules/PageList';

class BasicPageList extends Component {
  componentDidMount() {
    this.props.fetchPages();
  }

  render() {
    const { isLoaded } = this.props;
    return (
      <Layout>
        <Container>
          <PageNav>
            <h1>Základní stránky</h1>
            <Button tag={Link} to="/zakladni-stranky/new" color="primary">
              Nová základní stánka
            </Button>
          </PageNav>
          <Loader loaded={isLoaded}>
            <PageList />
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchPages }
)(BasicPageList);



// WEBPACK FOOTER //
// ./src/pages/BasicPageList.js